export const ID = 'ROLES';

export const LOAD_ROLES = `${ID}/LOAD_ROLES`;
export const LOAD_ROLES_COMPLETED = `${ID}/LOAD_ROLES_COMPLETED`;
export const LOAD_ROLES_FAILED = `${ID}/LOAD_ROLES_FAILED`;
